import { render, staticRenderFns } from "./TheHeaderWebStudent.vue?vue&type=template&id=e79cf890&scoped=true&"
import script from "./TheHeaderWebStudent.vue?vue&type=script&lang=js&"
export * from "./TheHeaderWebStudent.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderWebStudent.vue?vue&type=style&index=0&id=e79cf890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79cf890",
  null
  
)

export default component.exports